<label class="sis-checkbox" [for]="inputId">
  <input
    [id]="inputId"
    type="checkbox"
    [checked]="checkedValue"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel"
    (change)="onChangeEvent($event)">
  <span class="sis-checkbox-mark" aria-hidden="true"></span>
  <span class="sis-checkbox-label" *ngIf="label">{{ label }}</span>
  <span class="sis-checkbox-label" *ngIf="!label"><ng-content></ng-content></span>
</label>
